<template>
  <div class="iid-ied-main">
    <ReportsHomeV2 :jsReport="false" title="IID/IED" placeholder="Job No" @generateReport="generate" ref="report" :sections="sections" :inputValue.sync="jobNo" :inputDisabled="true">
     <div slot="Details_Report Type">
        <Dropdown v-if="this.jobTypeInfo == 'I'" placeholder="IID Format" :items="formatList1" itemKey="format" :selectedObject.sync="selectedFormat"
          :errorMessage.sync="formatError" :isRequired="true" />
        <Dropdown v-else-if="this.jobTypeInfo == 'E'" placeholder="IED Format" :items="formatList2" itemKey="format" :selectedObject.sync="selectedFormat"
          :errorMessage.sync="formatError" :isRequired="true" />
        <div v-else class="job-type-error">Job Type not found.</div>
      </div> 
    </ReportsHomeV2>

    <Loader :isVisible.sync="loading" :loadingText="loadingText" :isFullScreen="true" />
    <PopupV2 :show="popupShow" :type="popupType" :title="popupTitle" :content="popupContent" @buttonClicked="popupShow = false" />
  </div>
</template>

<script>
/* eslint-disable */
import ReportsHomeV2 from '@/pages/ReportsV2/ReportsHome';

export default {
  components: {
    ReportsHomeV2
  },
  data: function() {
    return {
      sections: [
        { name: 'Details', child: ['Report Type'], show: true }
      ],
      
      loading: false,
      loadingText: '',

      jobDetails: null,
      jobNo: '',
      rpt: '',

      popupShow: false,
      popupType: '',
      popupTitle: '',
      popupContent: '',

      //Job Type: Import
      formatList1: [
        { format: 'North Port', formatKey: 'NP' },
        { format: 'West Port', formatKey: 'WP' },
        { format: 'West Port Conventional', formatKey: 'WPConv' },
      ],

      //Job Type: Export 
      formatList2: [
        { format: 'North Port', formatKey: 'NP' },
        { format: 'West Port', formatKey: 'WP' },
      ],
      
      selectedFormat: null,
      formatError: '',

      jobTypeInfo: '',
    }
  },
  props: {
  },
  methods: {
    formatDateTime: function(dateTime, format) {
      if (!dateTime) // if API didn't return a date, dont assign anything
        return; // returning null here would create another field in the data with a null value

      return this.$dateTime.getDateTime(new Date(dateTime), format);
    },
    generate: async function() {
      this.formatError = '';
      if (!this.selectedFormat) {
        this.formatError = 'Please choose your format';
        return;
      }

      if (this.jobTypeInfo == 'I') {
        this.rpt = 'RPTIID';
      }
      else if (this.jobTypeInfo == 'E') {
        this.rpt = 'RPTIED';
      }

      this.loading = true;
      this.loadingText = 'Getting Details';
      var details = await this.$apiCallV2(`/FreightForwarding/JobDetails?jobno=${this.jobNo}&rpt=${this.rpt}`);
      this.loading = false;
      
      if (details) {
        this.jobDetails = details['JobDetails']['Job'];
        
        // Get date format from user options in vuex
        let preferredDateFormat = this.$store.state['preferredDateFormat'];

        // Format and workaround to get the data
        this.jobDetails['PODETAInfo'] = this.formatDateTime(this.jobDetails['POD ETA'], preferredDateFormat);
        this.jobDetails['POLETAInfo'] = this.formatDateTime(this.jobDetails['POL ETA'], preferredDateFormat);
        this.jobTypeInfo = this.jobDetails['Job Type'];

        // if(this.jobDetails.hasOwnProperty('ShipMarks')){
        //   this.jobDetails['ShipMarkInfo'] = this.jobDetails['ShipMarks'][0]['ShipMark'];
        // }

        // // To get the goods description
        // if(this.jobDetails.hasOwnProperty('GoodsDesc')){
        //   this.jobDetails['GoodsDescriptionInfo'] = '';
        //   this.jobDetails['GoodsDesc'].forEach(element => {
        //     this.jobDetails['GoodsDescriptionInfo'] += `\r${element['GoodsDescription']}`; 
        //     console.log(this.jobDetails['GoodsDescriptionInfo']);
        //   });
        // }

        if (this.jobDetails.hasOwnProperty('ShipMarks')) { // get shipping marks and limit to 25 lines
          this.jobDetails['ShipMarkInfo'] = '';
          for (let i = 0; i < this.jobDetails['ShipMarks'].length && i < 25; i++) {
            this.jobDetails['ShipMarkInfo'] += `\r\n${this.jobDetails['ShipMarks'][i]['ShipMark']}`; 
          }
        }
        
        if (this.jobDetails.hasOwnProperty('GoodsDesc')) { // get goods desc and limit to 25 lines
          this.jobDetails['GoodsDescriptionInfo'] = '';
          for (let i = 0; i < this.jobDetails['GoodsDesc'].length && i < 25; i++) {
            this.jobDetails['GoodsDescriptionInfo'] += `\r\n${this.jobDetails['GoodsDesc'][i]['GoodsDescription']}`;
          }
        }

        // To get the container numbers
        if(this.jobDetails.hasOwnProperty('ContDetail')){
          this.jobDetails['ContainerNoAll'] = '';
          this.jobDetails['ContDetail'].forEach(element => {
            this.jobDetails['ContainerNoAll'] += `\r${element['Container No']}`; 
            console.log(this.jobDetails['ContainerNoAll']);
          });
        }
        
        if (this.jobDetails.hasOwnProperty('Company')){
          this.jobDetails['ReportHdrLine1Info'] = this.jobDetails['Company']['ReportHdrLine1'];
          this.jobDetails['FMSNorthPortAccInfo'] = this.jobDetails['Company']['FMSNorthPortAcc'];
          this.jobDetails['FMSWestPortAccInfo'] = this.jobDetails['Company']['FMSWestPortAcc'];
        }

        if (this.jobTypeInfo == 'I') {
          this.$refs['report'].generateReportDesigner(`IID_${this.selectedFormat['formatKey']}.json`, this.jobDetails);
        }
        else if (this.jobTypeInfo == 'E') {
          this.$refs['report'].generateReportDesigner(`IED_${this.selectedFormat['formatKey']}.json`, this.jobDetails);
        }
      } else {
        this.popupShow = true;
        this.popupType = 'error';
        this.popupTitle = 'Invalid Job No';
        this.popupContent = `Invalid Job No ${this.jobNo}`;
      }
    },
  },
  async mounted() {    let query = this.$route.query;
    if (query['jobno']) {
      this.jobNo = query['jobno'];
    }

    // To get the job type for dropdown selection
    this.loading = true;
    this.loadingText = 'Getting Details';
    var details = await this.$apiCallV2(`/FreightForwarding/JobDetails?jobno=${this.jobNo}`);
    this.loading = false;

    if (details) {
      this.jobDetails = details['JobDetails']['Job'];
      this.jobTypeInfo = this.jobDetails['Job Type'];
    } else {
      this.popupShow = true;
      this.popupType = 'error';
      this.popupTitle = 'Invalid Job No';
      this.popupContent = `Invalid Job No ${this.jobNo}`;
    }

  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.iid-ied-main {
  width: 100%;
  height: 100%;
}
.job-type-error {
  color: red; 
}
</style>